import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import Link from 'next/link'

interface ProductInfoVariantItemProps {
  isActive?: boolean
  onClick?: () => void
  href?: string
  title: string
  imageUrl: string
  linkRef?: React.Ref<HTMLAnchorElement>
  buttonRef?: React.Ref<HTMLButtonElement>
}

export const ProductInfoVariantItem = ({
  isActive,
  onClick,
  href,
  imageUrl,
  title,
  linkRef,
  buttonRef,
}: ProductInfoVariantItemProps) => {
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Prevent default link navigation, we'll handle it with onClick handler
    e.preventDefault()
    onClick?.()
  }

  const commonClassName = cn(
    'block h-9 cursor-pointer rounded-full border-2 border-neutral-600/30 p-0.5 transition-colors hover:border-primary',
    isActive && 'border-primary'
  )

  const imageElement = (
    <Image
      src={ImageHelper.getImageUrl(imageUrl, '100_113')}
      alt={`color ${title}`}
      width={50}
      height={30}
      className='h-full w-full rounded-full object-cover md:w-[50px]'
      unoptimized
    />
  )

  // Render Link if href is provided, otherwise render button for backward compatibility
  if (href) {
    return (
      <Link
        ref={linkRef}
        href={href}
        onClick={handleLinkClick}
        className={commonClassName}
      >
        {imageElement}
      </Link>
    )
  }

  return (
    <button ref={buttonRef} onClick={onClick} className={commonClassName}>
      {imageElement}
    </button>
  )
}
